import React from "react";
import { Link as RouterLink } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { AppBar, Box, Grid, Toolbar, makeStyles } from "@material-ui/core";
import { Logo, UnsupportedBrowserAlert } from "@packages/ui";
import getBrandFromUrl from "../../utils/getBrandFromUrl";
import getServiceFromUrl from "src/utils/getServiceFromUrl";

const brand = getBrandFromUrl();

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "white",
    borderBottom: `5px solid ${theme.palette.primary.main}`,
  },
  logo: {
    marginTop: 5,
    height: brand === "Ace" ? "50px" : brand === "Firefly" ? "45px" : brand == "Dollar" ? "45px" : brand == "Thrifty" ? "45px" : "32px",
  },
}));

const TopBar = ({ className, ...rest }) => {
  const classes = useStyles();
  const service = getServiceFromUrl();
  const brand = getBrandFromUrl();

  return brand == "Generic" ? <></> : <AppBar className={clsx(classes.root, className)} elevation={0} {...rest}>
    <UnsupportedBrowserAlert />
    <Toolbar>
      <Grid container justify="center" align-items="center">
        <RouterLink to={service === "MJP" ? "/login" : "checkin/login"}>
          <Logo brand={brand} className={classes.logo} />
        </RouterLink>
      </Grid>
      <Box flexGrow={1} />
    </Toolbar>
  </AppBar>

    ;
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
};

export default TopBar;
